import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "consent-box",
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing flex-grow-1 overflow-y-auto"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "form-check form-group mb-15 mb-sm-20 mb-md-25"
}
const _hoisted_4 = {
  class: "form-check-label fw-medium position-relative top-1",
  for: "accept"
}
const _hoisted_5 = { class: "row justify-content-center" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = {
  class: "alert alert-danger alert-dismissible fade border-0 border-danger-subtle border-top rounded-0 m-0 mb-25",
  role: "alert",
  id: "errorMessage"
}
const _hoisted_8 = { class: "text-end mb-25" }
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_AlertModal = _resolveComponent("AlertModal")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createCommentVNode(" <div class=\"d-flex justify-content-center h-100 align-items-center\" v-if=\"consent_details === undefined\">\n                    <SpinnerLoading class=\"h-auto\"/>\n                </div> "),
      _createElementVNode("div", {
        class: "card-body p-15 p-sm-20 p-md-25",
        innerHTML: _ctx.consent.current_version?.body
      }, null, 8 /* PROPS */, _hoisted_2)
    ]),
    (_ctx.consent.current_version?.has_checkbox ?? false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input shadow-none",
            type: "checkbox",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.accept) = $event)),
            id: "accept"
          }, null, 512 /* NEED_PATCH */), [
            [_vModelCheckbox, _ctx.accept]
          ]),
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.consent.current_version?.checkbox_disclaimer ?? ''), 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" ERROR MESSAGE "),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('error.something_went_wrong')), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideError && _ctx.hideError(...args))),
            "aria-label": "Close"
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        disabled: !_ctx.nextEnabled,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.initConsent())),
        class: "default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16"
      }, [
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.$t('cta.withdraw_consent')), 1 /* TEXT */)
            ], 64 /* STABLE_FRAGMENT */))
          : (_openBlock(), _createBlock(_component_SpinnerLoading, {
              key: 1,
              small: true,
              class: "h-auto mb-0"
            }))
      ], 8 /* PROPS */, _hoisted_9)
    ]),
    _createVNode(_component_AlertModal, {
      id: "alertModal",
      title: _ctx.$t('cta.withdraw_consent'),
      dismissible: false,
      message: _ctx.$t('feature.auth.$withdraw_consent.success_message'),
      onConfirm: _ctx.redirect
    }, null, 8 /* PROPS */, ["title", "message", "onConfirm"]),
    _createVNode(_component_ConfirmModal, {
      id: "confirmModal",
      title: _ctx.$t('cta.withdraw_consent'),
      message: _ctx.$t('feature.auth.$withdraw_consent.alert_message'),
      onConfirm: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submitConsent()))
    }, null, 8 /* PROPS */, ["title", "message"])
  ], 64 /* STABLE_FRAGMENT */))
}